import { ArrowDownIcon } from './arrow-down-icon';
import { ArrowUpIcon } from './arrow-up-icon';
import { BankingIcon } from './banking-icon';
import { BusinessIcon } from './business-icon';
import { CreditCardIcon } from './credit-card-icon';
import { FinancialAdvisorIcon } from './financial-advisor-icon';
import { InsuranceIcon } from './insurance-icon';
import { MortgageIcon } from './mortgage-icon';
import { OnlineBrokerIcon } from './online-broker-icon';
import { PersonalLoansIcon } from './personal-loans-icon';
import { StudentLoansIcon } from './student-loans-icon';

export {
  ArrowDownIcon,
  ArrowUpIcon,
  BankingIcon,
  BusinessIcon,
  CreditCardIcon,
  FinancialAdvisorIcon,
  InsuranceIcon,
  MortgageIcon,
  OnlineBrokerIcon,
  PersonalLoansIcon,
  StudentLoansIcon,
};
